import CryptoJS from "crypto-js"
const SECRET_KEY = CryptoJS.enc.Utf8.parse("1234123412341234");
const SECRET_IV = CryptoJS.enc.Utf8.parse("1234123412341234");
var utils = {
    //加密
   encrypt(data) {
        if (typeof data === "object") {
          try {
            data = JSON.stringify(data);
          } catch (error) {
            console.log("encrypt error:", error);
          }
        }
        const dataHex = CryptoJS.enc.Utf8.parse(data);
        const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
          iv: SECRET_IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.ciphertext.toString();
    },
    //解密
    decrypt(data) {
        const encryptedHexStr = CryptoJS.enc.Hex.parse(data);
        const str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
        const decrypt = CryptoJS.AES.decrypt(str, SECRET_KEY, {
          iv: SECRET_IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    },
   IEVersion() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            return false
        } else if(isEdge) {
            return false//edge
        } else if(isIE11) {
            return true; //IE11  
        }else{
            return true;//不是ie浏览器
        }
    },
    newsTypeAll:[
        {'title':'抗击新冠肺炎，江苏药师在行动',active:false,dlb:'10016',show:false},
        {'title':'最新资讯',active:true,dlb:'10001',show:true},
        {'title':'政策法规',active:false,dlb:'10003',show:true},
        {'title':'协会动态',active:false,dlb:'10004',show:true},
        {'title':'继续教育',active:false,dlb:'10005',show:true},
        {'title':'党群工作',active:false,dlb:'10017',show:true},
        {'title':'健康驿站',active:false,dlb:'10006',show:true},
        {'title':'精准助老',active:false,dlb:'10018',show:true},
        {'title':'药师论坛',active:false,dlb:'10007',show:true},
        {'title':'人才交流',active:false,dlb:'10008',show:true},
        {'title':'办事指南',active:false,dlb:'10009',show:true},
        {'title':'他山之石',active:false,dlb:'10010',show:true},
        {'title':'药师风采',active:false,dlb:'10011',show:true},
        {'title':'行为规范',active:false,dlb:'10013',show:true},
        {'title':'好药师专栏',active:false,dlb:'10016',show:true},
        {'title':'联系我们',active:false,dlb:'10012',show:true},
        {'title':'搜索列表',active:false,dlb:'10014',show:false},
        {'title':'图片新闻',active:false,dlb:'16',show:false},
      
       
    ],
    newsTypeAllShort:[
        {'name':'首页',id:'Home',dlb:'1',router:'Home',class:'icon1'},
        {'name':'短视频',id:'ShortcutVideo',dlb:'2',router:'ShortcutVideo',class:'icon2'},
        {'name':'知识手册',id:'NewsList',dlb:'10012',router:'NewsList',class:'icon3'},
        {'name':'前沿信息',id:'NewsList2',dlb:'10013',router:'NewsList',class:'icon4'},
        {'name':'新药政策',id:'NewsList3',dlb:'10014',router:'NewsList',class:'icon5'},
        {'name':'历年课程',id:'AnnualCourses',dlb:'10015',router:'AnnualCourses',class:'icon6'}
    ],
    formDate:{
        sf: {
            'name': '(省/市)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        sx: {
            'name': '(市/县)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        xq: {
            'name': '(县/区)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        WorkName: {
            'name': '姓名','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Cardid: {
            'name': '证件号码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Sex:{
            'name': '性别','value':'','option':'sex','showSelect':true,'select':['男','女']
        },
        educity:{
            'name':'执业注册属地','value':'',option:'eduadd','showSelect':true,'select':[
                '南京市','无锡市','徐州市','常州市','苏州市','南通市','连云港市','淮安市','盐城市',
                '扬州市','镇江市','泰州市','宿迁市','省外市'
            ]
        },
        NATIVEPLACE: {
            'name': '证书考取属地','value':'','placeholder':'请填写','option':'userName','showSelect':true,'select':[
               '南京市','无锡市','徐州市','常州市','苏州市','南通市','连云港市','淮安市','盐城市','扬州市','镇江市','泰州市','宿迁市',
                '省外市']
        },
        NATION:{
            'name':'民族','value':'',option:'NATION','showSelect':true,'select':
            ['汉族','蒙古族','回族','藏族','维吾尔族','彝族','壮族','布依族','朝鲜族','傣族',
            '德昂族','满族','侗族','瑶族','白族','土家族','哈尼族','景颇族', '哈萨克族','黎族',
            '傈僳族','畲族','高山族','拉祜族','水族','东乡族','纳西族','柯尔克孜族','土族','达斡尔族',
            '仫佬族','羌族','布朗族', '撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族',
            '怒族','乌孜别克族','俄罗斯族','鄂温克族','塔塔尔族','独龙族', '鄂伦春族','赫哲族','门巴族', '珞巴族',
            '基诺族','保安族','京族','佤族','裕固族','苗族'],
        },
        MEDULEVEL:{
            'name':'学历','value':'',option:'education','showSelect':true,'select':
            ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        },
        MEDUSPEC:{
            'name':'专业','value':'',option:'education','showSelect':true,'select':['中药学','药学','相关专业'],
        },
        sort: {
            'name':'资格证书类别','value':'',option:'certificate','showSelect':true,'select':['执业药师','从业药师',''],
        },
        ExtentOne:{
            'name':'执业类别','value':'',option:'operation','showSelect':true,'select':['药学','中药学','药学和中药学'],
        },
        QualiCode:{
            'name':'资格证书号或管理号','value':'',option:'operation','showSelect':false,type:'date'
        },
        ATTEYEAR: {
            'name':'认定年份','value':'','placeholder':'请填写，如：考试年月',option:'time','showSelect':false
        },
        zQualiCode:{
            'name':'中药资格证书号管理号','value':'',option:'operation','showSelect':false,type:'date'
        },
        zATTEYEAR: {
            'name':'中药证书批准时间','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
       
        ExtentTwo:{
            'name':'执业范围','value':'',option:'operatorScope','showSelect':true,'select':
            ['其他','生产','批发','零售','使用','检验','无'],
        },
        WorkUnit:{
            'name':'工作单位','value':'','placeholder':'请填写',option:'company','showSelect':false
        },
        HANDSETPHONE:{
            'name':'手机号码','value':'','placeholder':'请填写',option:'mobilePhone','showSelect':false
        },
        MEDUSCHOOL:{
            'name':'毕业学校','value':'','placeholder':'请填写',option:'school','showSelect':false
        },
        MEDUTIME:{
            'name':'毕业时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        technicOne:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['卫生技术人员','正高级','副高级','中级','初级','员级','无'],
        },
        JOBLEVEL:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        WorkStat:{
            'name':'从事岗位','value':'','placeholder':'请填写',option:'station','showSelect':false
        },
        address:{
            'name':'通讯地址','value':'','placeholder':'请填写',option:'graduation','showSelect':false
        },
        postalcode:{
            'name':'邮政编码','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        LINKPHONE:{
            'name':'单位电话','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        email:{
            'name':'E-mail','value':'','placeholder':'请填写',option:'email','showSelect':false
        },
        grjl:{
            'name':'个人简历','value':'','placeholder':'请填写',option:'email','showSelect':false,typpe:'textarea'
        }
      },
      enrollStr (str) {
        let str2 = ''
        if (str === 'face') {
            str2 = '函授'
        } else if (str === 'online') {
            str2 = '网络'
        } else if (str === 'repair') {
            str2 = '补修'
        }
        return str2
      },
      clear () {
        window.localStorage.clear();
      },
      token: {
        set (token) {
              window.localStorage.setItem("token", token);
          },
          get () {
              return window.localStorage.getItem('token');
          },
        remove () {
          window.localStorage.removeItem('token')
        }
      },
      news: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("newsIndex", str);
        },
        get () {
          return window.localStorage.getItem('newsIndex');
        },
        setList (str) {
            window.localStorage.setItem("Keyword", str);
        },
        getList () {
            return   window.localStorage.getItem("Keyword");
        }
      },
      userName: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("userName", str);
        },
        get () {
          return window.localStorage.getItem('userName');
        },
      },
      courseId: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("courseNum", str);
        },
        get () {
          return window.localStorage.getItem('courseNum');
        },
      },
      enroll: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("enrollName", str);
        },
        get () {
          return window.localStorage.getItem('enrollName');
        },
      },
      info: {
        set (str) { // 获取详细的新闻
         window.localStorage.setItem("info", str);
        },
        get () {
         return window.localStorage.getItem('info');
        }, 
      }
    }
    export default utils
    


// WEBPACK FOOTER //
// ./src/utils/index.js